var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Download",
    transform: "translate(-1793 -282)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21152",
    "data-name": "Group 21152",
    transform: "translate(1793 282)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_896",
    "data-name": "Ellipse 896",
    cx: 19,
    cy: 19,
    r: 19,
    transform: "translate(0 0)",
    fill: "#ededf2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21194",
    "data-name": "Group 21194",
    transform: "translate(0 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4143",
    "data-name": "Path 4143",
    d: "M9.2.3A1.032,1.032,0,0,0,7.743.3a1.02,1.02,0,0,0,0,1.447l3.042,3.029H1.028a1.023,1.023,0,1,0,0,2.047h9.758L7.743,9.85A1.026,1.026,0,0,0,9.2,11.3l4.8-4.775a1.019,1.019,0,0,0,0-1.447Zm0,0",
    transform: "translate(1818.259 292.895) rotate(90)",
    fill: "#505465"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5521",
    "data-name": "Rectangle 5521",
    width: 18.922,
    height: 2.23,
    rx: 1.115,
    transform: "translate(1803 309.579)",
    fill: "#505465"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.b3f6660a7db97ab0db2fae9932551061.svg";
export { ForwardRef as ReactComponent };